/**
 * @returns {boolean}
 */
export function useRTL() {
  var _document, _document$documentEle;

  return ((_document = document) == null ? void 0 : (_document$documentEle = _document.documentElement) == null ? void 0 : _document$documentEle.dir) === 'rtl';
}